module.exports = __webpack_public_path__ + "img/outdoor.74e16083.svg";